// @flow

import dayjs from 'dayjs';

export const nextCheckIn = (interval: number, updatedAt: Date) =>
  dayjs()
    .add(interval, 'milliseconds')
    .diff(dayjs().diff(updatedAt), 'milliseconds');
